import React from 'react';
import {apiService} from '../common/apiCallService';
import Loading from './Loading.js';
import {baseUrl} from '../common/config.js';
import {BrowserRouter as Router, Route, Link} from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from "react-js-pagination";
import Paper from 'material-ui/Paper';
import moment from 'moment';
import { Redirect } from 'react-router';
import HandReplayer from './HandReplayer/HandReplayer.js';
import ReplayHand from './HandReplayer/ReplayHand.js';
import MediaQuery from 'react-responsive';
import {domain} from '../common/config.js';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
let PartyPokerIcon = "//"+domain+"/images/replayerIcons/PartyPokerIcon.png";
import DownloadRawhands from './PokerWatchComp/DownloadRawhands.js'
import * as actions from '../store/actions/index';
import { connect } from 'react-redux';
import { createVirtualPageLoad, closeVirtualPage } from '../common/commonService'
import queryString from 'query-string';

const customContentStyle = {
  width: '100%',
  maxWidth: 'none'
};

class PlayerDetails extends React.Component {
  constructor(props)
  {
    super(props);
    this.state = {
      shift:'',
      fromDate: '',
      players_alias: '',
      toDate: '',
      fromTime: '',
      toTime: '',
      timeString: "00:00",
      playerDetails: [],
      loading: true,
      open: false,
      activePage: 1,
      max: 10,
      offset: 0,
      totalGame: 0,
      sortBy: 'asc',
      currColumn: 'profit',
      sortColumn: 'Profit/Loss',
      totalProfit: '',
      totalRake: '',
      openHandRep: false,
      loginRedirect: false,
      title: 'Player Details',
      access: JSON.parse(localStorage.getItem('userRole')),
      gameDtls:{},
      gameNo:"",
      accountName:'',
      partitionDate:''
    }
    

    if(props.location.pathname=="/playerSummary"){
        this.state.players_alias=localStorage.getItem('alias'),
        this.state.fromDate=moment(new Date()).subtract(1,'days').format("YYYY-MM-DD HH:mm:ss"),
        this.state.toDate=moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        this.state.fromTime=moment(new Date()).format("HH:mm:ss"),
        this.state.toTime=moment(new Date()).format("HH:mm:ss"),
        this.state.shift='Select'
    }
    else{
      this.state.accountName=props.match.params.accountName
      this.state.players_alias=props.match.params.players_alias
      this.state.fromDate=props.match.params.date
      this.state.toDate=props.match.params.toDate
      this.state.fromTime=props.match.params.fTime
      this.state.toTime=props.match.params.tTime
      this.state.shift=props.match.params.shift
    }

    this.handlePageChange = this.handlePageChange.bind(this);
    this.callApi = this.callApi.bind(this);
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.sortingForMob = this.sortingForMob.bind(this);
    this.sorting = this.sorting.bind(this)
    this.openFromDateCalender = this.openFromDateCalender.bind(this)
    this.handleFromDate = this.handleFromDate.bind(this)
    this.handleFromTime = this.handleFromTime.bind(this);
    this.openToDateCalender = this.openToDateCalender.bind(this)
    this.handleToDate = this.handleToDate.bind(this)
    this.handleToTime = this.handleToTime.bind(this);
    this.callApi();
  }

  componentDidMount() {
    createVirtualPageLoad("/playerDetails")
  }

  componentWillUnmount() {
    closeVirtualPage()
  }

  openToDateCalender () {
   this.refs.ToDatePicker.openDialog()
  };


  handleToTime(event, time){
      this.setState({
        toDate:this.state.toDate+' '+moment(time).format("HH:mm:ss"),
        toTime:moment(time).format("HH:mm:ss")
      })
  }

  handleToDate(event, date){
      this.setState({toDate: moment(date).format("YYYY-MM-DD")})
      this.refs.ToTimePicker.openDialog()
  }

  openFromDateCalender () {
   this.refs.FromDatePicker.openDialog()
  };

  handleFromTime(event, time){
   this.setState({
      fromDate:this.state.fromDate+' '+moment(time).format("HH:mm:ss"),
      fromTime:moment(time).format("HH:mm:ss")
    })
  }

  handleFromDate(event, date){
      this.setState({fromDate: moment(date).format("YYYY-MM-DD")})
      this.refs.FromTimePicker.openDialog()
  }
  onTimerCancel(index){
      if(index==1){
        this.state.fromDate=this.state.fromDate+' '+"00:00:00"
        this.state.fromTimeZoneDate=this.state.fromDate
      }
      else {
        this.state.toDate=this.state.toDate+' '+"00:00:00"
        this.state.toTimeZoneDate=this.state.toDate
      }
        this.forceUpdate()
  }
  callApi() {
    this.setState({loading: true})
    apiService(baseUrl + '/pokerWatch/playerDetails', {
      "fromDate": this.state.fromDate,
      "toDate": this.state.toDate,
      "fromTime":this.state.fromTime,
      "toTime":this.state.toTime,
      "shift":this.state.shift,
      "accountName": this.state.accountName,
      "max": this.state.max,
      "offset": this.state.offset,
      "sortBy": this.state.sortBy,
      "column": this.state.currColumn,
      'gameType':'cash'
    }, (data) => {
      this.setState({playerDetails: data.list, totalGame: data.count.totalCount, totalProfit: data.count.totalProfit, totalRake: data.count.totalRake})
      this.setState({loading: false})

    }, (data) => {
      this.setState({loading: false})
      if(data.status == 403) {
        localStorage.setItem("pathName", this.props.location.pathname)
        this.setState({loginRedirect: true})
      }
    })

  }
  handlePageChange(pageNumber) {
    this.setState({loading: true})
    this.setState({activePage: pageNumber});
    this.state.offset = (pageNumber - 1) * this.state.max
    this.callApi();

  }

  sorting(column) {

    this.setState({loading: true})
    if (column == this.state.currColumn) {
      if (this.state.sortBy == 'asc')
        this.state.sortBy = 'desc'
      else
        this.state.sortBy = 'asc'
    } else {
      this.state.sortBy = 'asc'
    }
    this.state.currColumn = column
    this.callApi();
  }
  sortingForMob(event) {
    this.setState({value: event.target.value});
    this.state.sortColumn = event.target.value
    if (this.state.sortColumn == 'gameNo')
      this.setState({sortColumn: 'Game No'})
    else if (this.state.sortColumn == 'players.startStack')
      this.setState({sortColumn: 'Start Stack'})
    else if (this.state.sortColumn == 'players.endStack')
      this.setState({sortColumn: 'End Stack'})
    else if (this.state.sortColumn == 'time')
      this.setState({sortColumn: 'Time'})
    else
      this.setState({sortColumn: 'Profit/Loss'})
    var value = event.target.value;
    if (value != null) {
      if (value == 0) {
        this.state.msg = "please select proper sort"
        this.handleOpen();
      } else {
        if (value == "gameNo" || value == "players.startStack" || value == "players.endStack" || value == "profit" || value == "time") {
          this.setState({value: '0'});
          this.sorting(value)
        }

      }
    }
  }

  handleOpen(gameNo, partitionDate) {
    this.setState({loading: true})
    apiService(baseUrl + '/pokerWatch/rawHandHist', {
      "gameNo": gameNo,
      "accountName": this.state.accountName,
      "partitionDate": partitionDate
    }, (data) => {
      if (data.handHistory) {
        this.setState({loading: false})
        var handHist = data.handHistory.replace(/\#\*\#/g, "<br/>")
        this.setState({open: true});
        document.getElementById("rawData").innerHTML = handHist
        this.setState({open: false});
        this.setState({open: true});
      } else {
        this.setState({loading: false})
        alert("No Data Available")
      }
    }, (data) => {
        if(data.status == 403) {
          localStorage.setItem("pathName", this.props.location.pathname)
          this.setState({loginRedirect: true})
        }
        this.setState({loading: false})
    })

  };

  handleClose() {
    this.setState({open: false});
  };




  render() {
    let fullVersion = 0
    console.log("navigator.appVersion-----------------------")
    console.log(navigator.appVersion)
    if (navigator.appVersion.indexOf("Mac") >= 0) {
      if (navigator.appVersion.indexOf("Mobile") >= 0) {
        let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2] + osVersion[3]);
        if (fullVersion > 12.10) {
          fullVersion = 13
        } else {
          fullVersion = 12
        }
      } else {
        let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        // console.log("osVersion",osVersion)
        if(osVersion){
          fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2]);
          if (fullVersion > 10.13) {
            fullVersion = 13
          } else {
            fullVersion = 12
          }
        } else {
          fullVersion = 12
        }
      }
    } else {
      fullVersion = 13;
    }
    
    this.props.setHeaderTitle(this.state.title)
    const style = {
      margin: 15,
      padding: 20
    };
    const actions = [< FlatButton label = "OK" primary = {
        true
      }
      onClick = {
        this.handleClose
      } />];
    const {fromDate, toDate, fromTime, toTime, shift, accountName, totalGame} = this.state
    return (
      <div>
      <div className="container">
        {this.state.loginRedirect && (
       <Redirect to={'/'}/>
     )}
        {this.state.loading
          ? <Loading/>
          : null}
        <Paper zDepth={1} rounded={false} className="resp-paper">
          <div className="row">
            <div className="col-sm-4">
              <b>Games:</b>{this.state.totalGame}
            </div>
            <div className="col-sm-4">
              <b>Rake:</b>{this.state.totalRake}</div>
            <div className="col-sm-4">
              <b>Profit/Loss:</b>{this.state.totalProfit}</div>
          </div><br/>
        {/*this.state.access.indexOf('PLAYER') !== -1
              ?<form className="form-inline row" >
                     <div className="form-group col-sm-3">
                        <TextField floatingLabelText="From Date:" onTouchTap={this.openFromDateCalender} value={this.state.fromDate}    />
                        <DatePicker ref="FromDatePicker" onChange={this.handleFromDate}  id="fromDate" style={{display:"none"}} />
                        <TimePicker ref="FromTimePicker" onDismiss={() =>this.onTimerCancel(1)} onChange={this.handleFromTime} id="fromTime" style={{display:"none"}}/>
                     </div>
                     <div className="form-group col-sm-3">
                        <TextField floatingLabelText="To Date" onTouchTap={this.openToDateCalender} value={this.state.toDate}    />
                        <DatePicker ref="ToDatePicker" onChange={this.handleToDate} id="toDate" style={{display:"none"}}/>
                        <TimePicker ref="ToTimePicker" onChange={this.handleToTime} onDismiss={() =>this.onTimerCancel(2)}  id="toTime" style={{display:"none"}}/>
                     </div>
                     <div className="form-group col-sm-3" style={{paddingTop:"2%"}} >
                       <RaisedButton disabled={!this.state.fromDate}   label="Search" onClick={this.callApi} primary={true}/>
                     </div>
              </form>
              :null
            */}

          <div className="row">
            <div className="col-sm-8 col-xs-12">
              <h3>{this.state.players_alias}&nbsp;
                Details</h3>
            </div>
            <div className="col-sm-2 col-xs-6">
              {/* <DownloadRawhands fromDate={fromDate} toDate={toDate} fromTime={fromTime} toTime={toTime} shift={shift} accountName={accountName} totalGame={totalGame} showType="button"/> */}
            </div>
            <div className="col-sm-2 col-xs-6">
                <Link to={{
                  pathname: `/SkillLevel`,
                  search:`?${queryString.stringify({ 
                    fromDate, 
                    toDate, 
                    fromTime, 
                    toTime, 
                    shift, 
                    logintype: "admin" ,
                    accountName: this.state.accountName
                  })}`, 
                  state: { prevPath: location.pathname }
                }}>
                <RaisedButton secondary={true}>
                  <b style={{
                    color: "white",
                    padding: "5px"
                  }}
                  data-e2e="statClick">
                    <i className="fa fa-bar-chart" style={{
                      color: "white",
                      fontSize: "1.5em"
                    }} aria-hidden="true"></i>
                  </b>
                </RaisedButton>
              </Link>
            </div>
          </div>

          <br/>
          <center>
            <div className="form-group">
              <select className="resp-table-select selectpicker form-control" onChange={this.sortingForMob} value={this.state.value}>
                <option value="0">Sort By {this.state.sortColumn}</option>
                <option value="gameNo">Game No</option>
                <option value="players.startStack">Start Stack</option>
                <option value="players.endStack">End Stack</option>
                <option value="profit">Profit/Loss</option>
                <option value="time">Time</option>
              </select>

            </div>
          </center>
          <div >
            <table className="resp-table resp-table-background" >
              <thead className="resp-table-head">
                <tr className="resp-table-tr">
                  <th onTouchTap={() => this.sorting('gameNo')} style={{
                    cursor: "pointer"
                  }} className="resp-table-th">Game No&nbsp;
                    <i className="fa fa-sort"></i>
                  </th>
                  <th onTouchTap={() => this.sorting('players.startStack')} style={{
                    cursor: "pointer"
                  }} className="resp-table-th">Start Stack&nbsp;
                    <i className="fa fa-sort"></i>
                  </th>
                  <th onTouchTap={() => this.sorting('players.endStack')} style={{
                    cursor: "pointer"
                  }} className="resp-table-th">End Stack&nbsp;
                    <i className="fa fa-sort"></i>
                  </th>
                  <th onTouchTap={() => this.sorting('profit')} style={{
                    cursor: "pointer"
                  }} className="resp-table-th">Profit/Loss&nbsp;
                    <i className="fa fa-sort"></i>
                  </th>
                  <th onTouchTap={() => this.sorting('time')} style={{
                    cursor: "pointer"
                  }} className="resp-table-th">Time&nbsp;
                    <i className="fa fa-sort"></i>
                  </th>
                  <th className="resp-table-th">Hole Cards</th>
                  <th className="resp-table-th"></th>
                </tr>
              </thead>
              <tbody className="resp-table-body">
                {this.state.playerDetails.map((item, key) => {
                  return (
                    <tr className="resp-table-tr"  key={key} >
                      <td key={key} onTouchTap={() => this.handleOpen(item.gameNo, item.partitionDate)} style={{
                        cursor: "pointer"
                      }} className="PlayerDetailstd resp-table-td">{item.gameNo}</td>
                      <td className="PlayerDetailstd resp-table-td">{item.startStack}</td>
                      <td className="PlayerDetailstd resp-table-td">{item.endStack}</td>
                      <td className="PlayerDetailstd resp-table-td">{item.profit}</td>
                      <td className="PlayerDetailstd resp-table-td">{item.time.value}</td>
                      <td className="PlayerDetailstd resp-table-td">{item.cards?item.cards:'---'}</td>
          
                      <td className="PlayerDetailstd resp-table-td">
                        <FlatButton label="PLAY" secondary={true} onTouchTap={() => this.setState({gameNo : item.gameNo,partitionDate:moment(item.partitionDate.value).startOf('day').format("YYYY-MM-DD HH:mm:ss"), openHandRep : true})}/>

                      </td>
                    </tr>
                  )
                })}

              </tbody>
            </table>
          </div>
          <MediaQuery maxWidth={760}>
            {(matches) => {
              if (matches) {
                return <Dialog contentStyle={customContentStyle} title="Hand History" actions={actions} modal={false} open={this.state.open} onRequestClose={this.handleClose} autoScrollBodyContent={true}>
                  <p id="rawData"></p>
                </Dialog>
              } else {
                return <Dialog title="Hand History" actions={actions} modal={false} open={this.state.open} onRequestClose={this.handleClose} autoScrollBodyContent={true}>
                  <p id="rawData"></p>
                </Dialog>
              }
            }}
          </MediaQuery>

          {this.state.openHandRep?<div style={{
          top: 0,
          left: 0,
          zIndex: 20000, 
          width: "100%", 
          height: "100%",
          position: "fixed",
          backgroundColor : '#2c2c34'
        }}>
        {fullVersion && fullVersion < 13 ? 
         <HandReplayer 
              replayerScreen={'fromPlayerDetails'}
              loginStatus = {true} 
              gameNo={this.state.gameNo} 
              partitionDate={this.state.partitionDate}
              accountName={this.state.accountName}
              playerAlias={this.state.players_alias}
              gameTypeForTitle={this.props.gameType} 
              fromDate={ this.state.fromDate}
              toDate= {this.state.toDate}
              gameType={this.props.gameType} 
              onClose={() => this.setState({ openHandRep: false })}
              /> :
              <ReplayHand 
              replayerScreen={'fromPlayerDetails'}
              loginStatus = {true} 
              gameNo={this.state.gameNo} 
              partitionDate={this.state.partitionDate}
              accountName={this.state.accountName}
              playerAlias={this.state.players_alias}
              gameTypeForTitle={this.props.gameType} 
              fromDate={ this.state.fromDate}
              toDate= {this.state.toDate}
              gameType={this.props.gameType} 
              onClose={() => this.setState({ openHandRep: false })}
              />}
        </div> : null}

        
          {/* <FullscreenDialog 
            actionButton={
              <FlatButton 
                label='Close' 
                style={{color: '#DE460F', overflow:'initial'}} 
                onClick={() => this.setState({openHandRep: false})}/>} 
                appBarStyle={{backgroundColor: '#1F1E23', borderBottom: '2px solid #DE460F'}} 
                titleStyle={{color: 'white'}} 
                style={{backgroundColor: '#2D2C34'}} 
                open={this.state.openHandRep}
                title={<AppBarContent gameDtls={this.state.gameDtls}
              />
            }
          >
            <HandReplayer 
              loginStatus = {true} 
              gameNo={this.state.gameNo} 
              playerAlias={this.state.players_alias}
              gameTypeForTitle={this.props.gameType} 
              onClose={() => this.setState({ openHandRep: false })}
              // playerDtlsList={this.state.playerDtlsList} 
              // actionDtlsList={this.state.actionDtlsList} 
              // defaultPlayersList={this.state.defaultPlayersList} 
              // defaultActionList={this.state.defaultActionList} 
              // rawData={this.state.rawData}
              />
          </FullscreenDialog> */}

          <div style={{
            textAlign: "center"
          }}>
            <Pagination prevPageText='Prev' nextPageText='Next' firstPageText='First' lastPageText='Last' activePage={this.state.activePage} itemsCountPerPage={this.state.max} totalItemsCount={this.state.totalGame} pageRangeDisplayed={5} onChange={this.handlePageChange}/>
          </div>
        </Paper>
      </div>
    </div>

    )
  }
}
const AppBarContent = props => {
  return (
     <div>
       <div className="row mobileFilter">
         <div className="col-sm-9 col-xs-9"><img src={PartyPokerIcon} style={{width:'30px' ,float:'left',marginTop:'20px'}}/><h3>&nbsp; &nbsp;Hand Replayer</h3></div>
            <div className='col-sm-2 col-xs-2'>
              <IconMenu
                   iconButtonElement={<i className="fa fa-info-circle" style={{color:'#DE460F'}}aria-hidden="true"></i>}
                   anchorOrigin={{horizontal: 'left', vertical: 'top'}}
                   targetOrigin={{horizontal: 'left', vertical: 'top'}}
                 >
                 <MenuItem primaryText="Game No" rightIcon={<b style={{right:'90px',margin:'0',fontWeight:'normal'}}>{props.gameDtls['gameNo']}</b>} />
                 <MenuItem primaryText="Time" rightIcon={<b  style={{right:'90px',margin:'0',fontWeight:'normal'}}>{moment(props.gameDtls['time']).format("MMMM Do YYYY, h:mm a")}</b>} />
                 <MenuItem primaryText="Game Type" rightIcon={<b  style={{right:'90px',margin:'0',fontWeight:'normal'}}>{props.gameDtls['gameInfo_gameType']}</b>} />
                 <MenuItem primaryText="money" rightIcon={<b style={{right:'90px',margin:'0',fontWeight:'normal'}}>{props.gameDtls['gameInfo_money']}</b>} />
                 <MenuItem primaryText="Table Info" rightIcon={<b  style={{right:'90px',margin:'0',fontWeight:'normal'}}>{props.gameDtls['tableInfo_name']}</b>} />
                 <MenuItem primaryText="currency" rightIcon={<b  style={{right:'90px',margin:'0',fontWeight:'normal'}}>{props.gameDtls['currency']}</b>} />
               </IconMenu>
            </div>
       </div>

       <div className="row hide-prop">
         <div className="col-sm-5 col-xs-4"><img src={PartyPokerIcon} style={{width:'30px' ,float:'left',marginLeft: '20px',marginTop:'20px'}}/><h3>&nbsp; &nbsp;Hand Replayer</h3></div>
         <div className='col-sm-4 col-xs-4'>
          <div className='row'>
            <div className="col-sm-2 col-xs-2"> <h6 style={{lineHeight:'0'}}><span style={{color:'#969696'}}>Game No:</span> {props.gameDtls['gameNo']}</h6></div>
          </div>
          <div className='row'>
            <div className="col-sm-2 col-xs-2"> <h6 style={{lineHeight:'0'}}><span style={{color:'#969696'}}>Time:</span> {moment(props.gameDtls['time']).format("MMMM Do YYYY, h:mm a")}</h6></div>
          </div>
          <div className='row'>
            <div className="col-sm-2 col-xs-2"> <h6 style={{lineHeight:'0'}}><span style={{color:'#969696'}}>Game Type:</span> {props.gameDtls['gameInfo_gameType']}</h6></div>
          </div>
         </div>
         <div className='col-sm-3 col-xs-3'>
          <div className='row'>
            <div className="col-sm-2 col-xs-2"> <h6 style={{lineHeight:'0'}}><span style={{color:'#969696'}}>Money:</span> {props.gameDtls['gameInfo_money']}</h6></div>
          </div>
          <div className='row'>
            <div className="col-sm-2 col-xs-2"> <h6 style={{lineHeight:'0'}}><span style={{color:'#969696'}}>Table Info:</span> {props.gameDtls['tableInfo_name']}</h6></div>
          </div>
          <div className='row'>
            <div className="col-sm-2 col-xs-2"> <h6 style={{lineHeight:'0'}}><span style={{color:'#969696'}}>Currency:</span> {props.gameDtls['currency']}</h6></div>
          </div>
         </div>
       </div>

    </div>

  )
}

const mapStateToProps = state => {
  return {
    gameType: state.multipleReportCards.gameType,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayerDetails);



/** WEBPACK FOOTER **
 ** ./src/components/PlayerDetails.js
 **/